// Override de desenvolvimento: aponta as chamadas da SGA_v2_api para uma
// instância local (ex.: http://localhost:9090).
// Só vale com o site aberto em localhost e com VUE_APP_LOCAL_API definido no
// .env.local (fora do git). Em build de homolog/produção a variável não existe
// e esta função devolve null, mantendo as URLs de sempre.
const localApi = () => {
  const url = process.env.VUE_APP_LOCAL_API;
  const host = window.location.hostname;
  const isLocalhost = host === "localhost" || host === "127.0.0.1";

  return url && isLocalhost ? url.replace(/\/+$/, "") : null;
};

export default localApi;
